<template>
  <main id="app">
    <div class="header">stripe支付演示</div>

    <form id="payment-form" @submit.prevent="handleSubmit">
      <!-- <div id="link-authentication-element" /> -->
      <div id="payment-element" />
      <!-- <div id="card-errors" class="error" role="alert"></div> -->
      <button id="submit" class="pay-button" :disabled="isLoading">
        立即支付
      </button>
    </form>
  </main>
</template>
  
  <script>
import { getKey } from "@/api/login/user";
import { loadStripe } from "@stripe/stripe-js";
export default {
  name: "StripePage",

  data() {
    return {
      publishableKey: "",
      stripe: "",
      isLoading: false,
      elements: null,
      messages: [],
    };
  },
  watch: {},
  async mounted() {
    await getKey().then(async (res) => {
      if (res.data?.stripePublicKey) {
        this.publishableKey = res.data.stripePublicKey;

        localStorage.setItem("publishableKey", this.publishableKey);
        this.stripe = await loadStripe(this.publishableKey);
        this.init();
      }
    });
  },
  methods: {
    async init() {
      const { clientSecret } = await fetch(
        "http://127.0.0.1:8080/create-payment-intent",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      ).then((res) => res.json());
      
      const elements = this.stripe.elements({ clientSecret });
      this.elements = elements;
      const options = {
        layout: {
          type: "accordion", // accordion tabs
          defaultCollapsed: true,
          radios: false,
          spacedAccordionItems: true,
        },
      };
      const paymentElement = elements.create("payment", options);
      paymentElement.mount("#payment-element");
      // const linkAuthenticationElement = elements.create("linkAuthentication");
      // linkAuthenticationElement.mount("#link-authentication-element");
      this.isLoading = false;
    },
    async handleSubmit() {
      if (this.isLoading) return;
      this.isLoading = true;
      const { error, paymentIntent } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          // return_url: `${window.location.origin}/return`
          return_url: `${window.location.origin}/OffLineResult`,
        },
      });
      alert(`支付成功! 订单ID: ${paymentIntent.id}`);
      if (error.type === "card_error" || error.type === "validation_error") {
        this.messages.push(error.message);
      } else {
        this.messages.push("An unexpected error occured.");
      }
      this.isLoading = false;
    },
  },
};
</script>
  
  <style scoped>
#app {
  height: 100vh;
  text-align: left;
  padding:0px 16px
}
main{
  height: 100vh;
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.pay-button {
  min-width: 343px;
  height: 44px;
  border-radius: 8px;
  /* 2-辅色 */
  background: #201f34;
  color: #fff;
  margin-top: 24px;
}
/* .StripeElement{
} */

</style>
  